<h3 *ngIf="partner">{{ 'Customer' | translate }}</h3>
<div>
  <p>{{ partner?.firstName }} {{ partner?.lastName }}</p>
  <p>{{ partner?.zip }}</p>
  <p *ngIf="partner?.firstName?.toLowerCase() != partner?.email?.toLowerCase()">{{ partner?.email }}</p>
</div>
